import React, { useEffect, useState } from 'react';
import styles from './ResetPasswordModal.module.scss';
import Modal from '../../../layout/modal/Modal';
import { connect } from 'react-redux';
import { closeModal, openModal } from '../../../../redux/modals/action';
import {
	Button,
	OutlinedInput,
	Checkbox,
	FormControlLabel,
	InputAdornment,
	IconButton,
	TextField,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CustomButton from '../../../layout/customButton/CustomButton';
import { setUserPassword } from '../../../../api/UserManagement/setUserPassword.api';
import CopyToClipboard from 'react-copy-to-clipboard';
import { setAlert } from '../../../../redux/alerts/action';
import { sendPasswordEmailToUser } from '../../../../api/UserManagement/sendPasswordEmail.api';
import { sendVerifyAddressEmailToUser } from '../../../../api/UserManagement/sendVerifyAddressEmail.api';

const ResetPasswordModal = (props) => {
	const { show, closeModal, openModal, userById, setAlert, currentUserName } =
		props;
	const [showPassword, setShowPassword] = useState(false);
	const [password, setPassword] = useState('');
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [confirmPassword, setConfirmPassword] = useState('');
	const [resetSuccess, setResetSuccess] = useState();
	const [verifyEmail, setVerifyEmail] = useState(false);

	const handleClose = () => {
		closeModal('resetPassword');
		setResetSuccess();
	};

	const handleChangeVerifyEmail = (event) => {
		setVerifyEmail(event.target.checked);
	};

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleClickShowConfirmPassword = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const handleCanel = () => {
		closeModal('resetPassword');
	};

	const handeResetPassword = async () => {
		if (password !== confirmPassword) {
			setAlert('error', 'Password mismatch.');
			return;
		}
		if (password.length < 8) {
			setAlert('error', 'Password must have at least 8 characters.');
			return;
		}
		let result = await setUserPassword(userById.id, password);
		if (result.data.success) {
			if (verifyEmail) {
				await sendVerifyAddressEmailToUser(
					currentUserName,
					userById.email
				);
			}
			setResetSuccess(true);
		} else {
			setAlert(
				'error',
				'Failed to reset password. Please Try another password.'
			);
		}
	};

	const handelPasswordChange = (e) => {
		setPassword(e.target.value);
	};

	const handelConfirmPasswordChange = (e) => {
		setConfirmPassword(e.target.value);
	};

	const handleDone = () => {
		closeModal('resetPassword');
		setResetSuccess();
	};

	const handleEmailPassword = async () => {
		await sendPasswordEmailToUser(
			currentUserName,
			userById.email,
			password
		);
		setAlert('success', 'Email has been sent.');
	};

	return (
		<div className={styles.reset_password}>
			<Modal show={show} close={handleClose}>
				{!resetSuccess && (
					<>
						<Button
							className={styles.back_btn}
							startIcon={
								<ArrowBackIosIcon
									className={styles.back_btn_icon}
								/>
							}
							size='small'
							onClick={() => openModal('addUserMgmt')}
						>
							Back to Edit User
						</Button>
						<h2 className={styles.header_title}>Reset Password</h2>
						<p className={styles.header_user}>
							User: {userById.fullName}
						</p>
						<div className={styles.password}>
							<form>
								<h3 className={styles.password_label}>
									New Password
								</h3>
								<OutlinedInput
									className={styles.password_field}
									type={showPassword ? 'text' : 'password'}
									fullWidth
									onChange={handelPasswordChange}
									endAdornment={
										<InputAdornment position='end'>
											<IconButton
												aria-label='toggle password visibility'
												edge='end'
												value={password}
												onClick={
													handleClickShowPassword
												}
												onMouseDown={
													handleMouseDownPassword
												}
											>
												{showPassword ? (
													<Visibility />
												) : (
													<VisibilityOff />
												)}
											</IconButton>
										</InputAdornment>
									}
								/>
								<p className={styles.password_helper_text}>
									Password must have at least 8 characters
								</p>
							</form>
						</div>
						<div className={styles.password}>
							<form>
								<h3 className={styles.password_label}>
									Confirm Password
								</h3>
								<OutlinedInput
									className={styles.password_field}
									type={
										showConfirmPassword
											? 'text'
											: 'password'
									}
									fullWidth
									onChange={handelConfirmPasswordChange}
									endAdornment={
										<InputAdornment position='end'>
											<IconButton
												aria-label='toggle password visibility'
												edge='end'
												value={confirmPassword}
												onClick={
													handleClickShowConfirmPassword
												}
												onMouseDown={
													handleMouseDownPassword
												}
											>
												{showConfirmPassword ? (
													<Visibility />
												) : (
													<VisibilityOff />
												)}
											</IconButton>
										</InputAdornment>
									}
								/>
							</form>
						</div>
						<FormControlLabel
							control={
								<Checkbox
									checked={verifyEmail}
									onChange={handleChangeVerifyEmail}
									sx={{
										'&.Mui-checked': {
											color: 'var(--primary)',
										},
										padding: '0',
										marginLeft: '9px',
										marginRight: '9px',
										alignSelf: 'flex-start',
									}}
								/>
							}
							label='Ask user to verify email address by clicking on the link in email when they sign in'
							className={styles.checkbox_group}
						/>
						<div className={styles.button_group}>
							<Button
								className={styles.cancel_btn}
								onClick={handleCanel}
							>
								Cancel
							</Button>
							<CustomButton
								width={166}
								height={42}
								onClick={handeResetPassword}
							>
								Reset
							</CustomButton>
						</div>
					</>
				)}
				{resetSuccess && (
					<>
						<h2 className={styles.success_header}>
							Successful password reset
						</h2>
						<p className={styles.success_user}>
							User: {userById.fullName}
						</p>
						<div className={styles.success_password}>
							<h3 className={styles.password_label}>Password</h3>
							<TextField
								fullWidth
								disabled
								value={password}
								type='password'
							/>
						</div>
						<CopyToClipboard text={password}>
							<Button className={styles.copy_password_btn}>
								Copy Password
							</Button>
						</CopyToClipboard>
						<div className={styles.success_button_group}>
							<Button
								className={styles.email_password_btn}
								onClick={handleEmailPassword}
							>
								Email Password
							</Button>
							<CustomButton
								width={166}
								height={42}
								onClick={handleDone}
							>
								Done
							</CustomButton>
						</div>
					</>
				)}
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	userById: state.userManagement.userById,
	currentUserName: state.signIn.displayName,
});

export default connect(mapStateToProps, { openModal, closeModal, setAlert })(
	ResetPasswordModal
);
